import { render } from "./DangerZone.vue?vue&type=template&id=607ac3df"
import script from "./DangerZone.vue?vue&type=script&lang=js"
export * from "./DangerZone.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__